module.exports = __webpack_public_path__ + "static/media/srilankaRound.837597a6.svg";